module.exports = __webpack_public_path__ + "img/arrow_down_white_32dp.b4291821.png";